import { createSlice } from "@reduxjs/toolkit";
export var initialState = {
    nodeSelections: {},
};
var storeSnapshot = function (state, action) {
    state.nodeSelections[action.payload.nodeId] = action.payload.snapshot;
};
var clearSnapshots = function (state) {
    state.nodeSelections = {};
};
var undoSnapshotsSlice = createSlice({
    name: "undoSnapshots",
    initialState: initialState,
    reducers: {
        storeSnapshot: storeSnapshot,
        clearSnapshots: clearSnapshots,
    },
});
var allActions = undoSnapshotsSlice.actions, reducer = undoSnapshotsSlice.reducer;
export var callableActions = {
    storeSnapshot: allActions.storeSnapshot,
    clearSnapshots: allActions.clearSnapshots,
};
export default reducer;
